import { usePathname } from "Components/Breadcrumb/breadcrumb.hooks";
import { ReduxState } from "Store/rootReducer";
import { useSelector } from "react-redux";

export const useOfferDocumentLink = (): string | undefined => {
  const { offerAccept } = useSelector((state: ReduxState) => state);
  return offerAccept.fileUrl;
};

export const isCheckoutTile = usePathname().pathname.includes("utsjekk");
